import "core-js/modules/es.object.assign.js";
var _excluded = ["children", "containerProps", "variant", "showOverlay", "onOverlayPress", "visible"],
    _excluded2 = ["containerProps"],
    _excluded3 = ["containerProps"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { styled, useVariantProps } from '@pyt/core/native';
import { Pressable } from '@pyt/micros';
import { useDevice } from '@pyt/hooks';
import React, { useEffect } from 'react';
import { useMemo } from 'react';
var StyledModal = styled('Modal');
var Overlay = styled(Pressable, {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#000000',
  opacity: 0.4
});
var Container = styled('View', {
  width: 300,
  height: 300,
  margin: 'auto',
  backgroundColor: 'white'
});
export var Modal = _ref => {
  var {
    children,
    containerProps: propContainerProps,
    variant = 'default',
    showOverlay = true,
    onOverlayPress,
    visible
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var vairantProps = useVariantProps(variant, 'modal');
  var {
    isBrowser
  } = useDevice();

  var _useMemo = useMemo(() => {
    var {
      containerProps
    } = vairantProps,
        restVariantProps = _objectWithoutProperties(vairantProps, _excluded3);

    return _objectSpread({
      containerProps: _objectSpread(_objectSpread({}, containerProps), propContainerProps)
    }, _objectSpread(_objectSpread({}, restVariantProps), props));
  }, [props, propContainerProps, vairantProps]),
      {
    containerProps
  } = _useMemo,
      restProps = _objectWithoutProperties(_useMemo, _excluded2);

  useEffect(() => {
    if (isBrowser && document.querySelector('body') !== null) {
      ;
      document.querySelector('body').style.overflow = visible ? 'hidden' : '';
    }
  }, [visible]);
  return React.createElement(StyledModal, _extends({
    animationType: "fade",
    transparent: true,
    visible: visible
  }, restProps), showOverlay ? React.createElement(Overlay, {
    onPress: event => onOverlayPress === null || onOverlayPress === void 0 ? void 0 : onOverlayPress(event),
    cursor: onOverlayPress ? 'pointer' : 'default'
  }) : null, React.createElement(Container, containerProps, children));
};